import { Carousel } from "@breuni-ui/carousel";
import { safeDefine } from "@breuni-ui/safe-define";
import { isElement } from "../utils/isElement";
import { isInBottomSheet, openDeeplink } from "@mobile-app/native-dialog";

export type OutfitClickDetails = {
  farbId: string;
  relativePath: string;
  index: number;
};
export type BestandteileTrackingData = {
  syan: string;
  farbId: string;
  targetUrl: string;
  position: number;
};

export type BestandteilTrackingData = {
  syan: string;
  farbId: string;
  targetUrl: string;
  taxonomieLevel3: string;
  index: number;
};

export default class KombiModulCarousel extends Carousel {
  private static openPDS(url: string): void {
    if (isInBottomSheet()) {
      openDeeplink(url);
    } else {
      window.open(url, "_self");
    }
  }

  private static getBestandteilTrackingData(
    parentElement: HTMLElement,
    currentTarget: HTMLElement,
  ): BestandteilTrackingData | null {
    const syan = parentElement.getAttribute("data-syan") ?? "";
    const farbId = parentElement.getAttribute("data-farb-id") ?? "";
    const taxonomieLevel3 =
      parentElement.getAttribute("data-taxonomie-level-3") ?? "";
    const targetUrl = (currentTarget.getAttribute("href") ?? "").replace(
      window.location.origin,
      "",
    );
    const rawIndex = parentElement.getAttribute("data-slide-index");
    if (rawIndex === null) {
      return null;
    }
    const index = parseInt(rawIndex, 10);
    return {
      index,
      farbId,
      syan,
      targetUrl,
      taxonomieLevel3,
    };
  }

  public connectedCallback(): void {
    super.connectedCallback();
    const buttons = this.querySelectorAll('[data-id="open-bestandteile"]');
    buttons.forEach((button) => {
      button.addEventListener("click", (ev) => {
        this.dispatchOutfitClickEvent(ev);
      });
    });
    const anchors = this.querySelectorAll('[data-id="open-bestandteil"]');
    anchors.forEach((anchor) => {
      anchor.addEventListener("click", (ev) => {
        this.handleBestandteilClickEvent(ev);
      });
    });
  }

  public getBestandteileTrackingData(): BestandteileTrackingData[] {
    return Array.from(this.querySelectorAll("article.reco-bestandteil")).map(
      (el) => {
        const syan = el.getAttribute("data-syan") ?? "";
        const farbId = el.getAttribute("data-farb-id") ?? "";
        const targetUrl = (
          el.querySelector("a.nui-copy")?.getAttribute("href") ?? ""
        ).replace(window.location.origin, "");
        const position = parseInt(
          el.getAttribute("data-slide-index") ?? "0",
          10,
        );
        return { syan, farbId, targetUrl, position };
      },
    );
  }

  private handleBestandteilClickEvent(ev: Event): void {
    ev.preventDefault();
    if (ev.currentTarget && isElement(ev.currentTarget)) {
      const { parentElement } = ev.currentTarget;
      if (parentElement) {
        const bestandteilTrackingData =
          KombiModulCarousel.getBestandteilTrackingData(
            parentElement,
            ev.currentTarget,
          );
        if (bestandteilTrackingData) {
          this.dispatchEvent(
            new CustomEvent<BestandteilTrackingData>("bestandteil:click", {
              detail: bestandteilTrackingData,
            }),
          );
        }
      }
      const href = ev.currentTarget.getAttribute("href");
      if (href !== null) {
        KombiModulCarousel.openPDS(href);
      }
    }
  }

  private dispatchOutfitClickEvent(ev: Event): void {
    if (ev.currentTarget && isElement(ev.currentTarget)) {
      const farbId = ev.currentTarget.getAttribute("data-farbid");
      const relativePath = ev.currentTarget.getAttribute("data-relative-path");
      const rawIndex = ev.currentTarget.getAttribute("data-slide-index");
      if (farbId !== null && relativePath !== null && rawIndex !== null) {
        const index = parseInt(rawIndex, 10);
        if (!Number.isNaN(index)) {
          this.dispatchEvent(
            new CustomEvent<OutfitClickDetails>("outfit:click", {
              detail: { farbId, relativePath, index },
            }),
          );
        }
      }
    }
  }
}

safeDefine("reco-kombi-modul-carousel", KombiModulCarousel);
